import type * as Oazapfts from '@oazapfts/runtime';

import { appConfig } from '@/config';
import { useAuth } from '@/hooks/use-auth';
import { useMe } from '@/hooks/use-me';

export type OazapftsApiFunction<TParams, TReturn> =
  | ((params: TParams, opts?: Oazapfts.RequestOpts) => Promise<TReturn>)
  | ((opts?: Oazapfts.RequestOpts) => Promise<TReturn>);

export function useInjectFeApiContext<F extends OazapftsApiFunction<any, any>>(
  apiCallFunc: F,
) {
  const auth = useAuth();
  const me = useMe();

  type TParams = Parameters<F>[0] extends Oazapfts.RequestOpts | undefined
    ? void
    : Parameters<F>[0];

  type TReturn = F extends (...args: any[]) => Promise<infer TReturn>
    ? TReturn
    : never;

  return async function feApi(params: TParams): Promise<TReturn> {
    const accessToken = await auth.getAccessToken();
    const baseUrl = `${appConfig.bffUrl}/plex`;

    const opts = {
      baseUrl,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'X-USER-EMAIL': me.email,
        'X-USER-NAME': me.displayName,
      },
    };

    const parameters = typeof params === 'undefined' ? [opts] : [params, opts];

    // @ts-expect-error as parameters can be either (params, opts) or (opts) it's really difficult to type it here, but the function is typed correctly when you use it
    return apiCallFunc(...parameters);
  };
}
